(function () {
  const container = document.querySelector('.package-selector-container');
  if (!container) return;

  const hasColorPower = container.querySelector('.color-swatch') !== null;

  let selectedColor = container.querySelector('.color-swatch.is-active')?.dataset.color;
  let selectedPower = container.querySelector('.power-btn.is-active')?.dataset.power;

  function filterPackages() {
    const cards = container.querySelectorAll('.package-selector__variant-group');
    let firstVisible = null;

    cards.forEach(card => {
      let show = false;
      if (!hasColorPower) {
        show = true;
      } else {
        show = card.dataset.color === selectedColor && card.dataset.power === selectedPower;
      }
      card.style.display = show ? '' : 'none';
      if (show && !firstVisible) firstVisible = card;
    });

    if (firstVisible) {
      const radio = firstVisible.querySelector('.package-selector__radio-input');
      if (radio && !container.querySelector('.package-selector__radio-input:checked')) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }

  container.querySelectorAll('.color-swatch').forEach(btn => {
    btn.addEventListener('click', () => {
      container.querySelectorAll('.color-swatch').forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');
      selectedColor = btn.dataset.color;
      filterPackages();
    });
  });

  container.querySelectorAll('.power-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      container.querySelectorAll('.power-btn').forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');
      selectedPower = btn.dataset.power;
      filterPackages();
    });
  });

  filterPackages();
})();
